import * as React from "react";
import {DocumentManager} from "../../Manager/PDFManager/DocumentManager";

export class SettingTabs extends React.Component<SettingTabsProps, SettingTabsState> {
    static defaultProps: Partial<SettingTabsProps> = {};

    constructor(props: SettingTabsProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            null
        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface SettingTabsProps {
    DocumentManager:DocumentManager;
}

interface SettingTabsState {

}

//#endregion "My Region"